import { alpha } from '@mui/material/styles';
import { buttonClasses } from '@mui/material/Button';
// ----------------------------------------------------------------------
const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];
// ----------------------------------------------------------------------
export function button(theme, selectedCompany, companyTheme) {
    const lightMode = theme.palette.mode === 'light';
    const rootStyles = (ownerState) => {
        const inheritColor = ownerState.color === 'inherit';
        const containedVariant = ownerState.variant === 'contained';
        const outlinedVariant = ownerState.variant === 'outlined';
        const textVariant = ownerState.variant === 'text';
        const softVariant = ownerState.variant === 'soft';
        const whiteVariant = ownerState.variant === 'white';
        const smallSize = ownerState.size === 'small';
        const mediumSize = ownerState.size === 'medium';
        const largeSize = ownerState.size === 'large';
        const xlSize = ownerState.size === 'xl';
        // Apply VDK button styles only when: VDK groep OR no customizations at all
        const isVDKGroep = selectedCompany?.name?.toLowerCase().includes('vdk groep') ||
            selectedCompany?.name?.toLowerCase().includes('vdkgroep') ||
            selectedCompany?.name?.toLowerCase() === 'vdk groep' ||
            (!companyTheme?.primaryColor && !companyTheme?.secondaryColor && !companyTheme?.fontFamily);
        const defaultStyle = {
            ...(inheritColor && {
                // CONTAINED
                ...(containedVariant && {
                    color: lightMode ? theme.palette.common.white : theme.palette.grey[800],
                    backgroundColor: lightMode ? theme.palette.grey[800] : theme.palette.common.white,
                    '&:hover': {
                        backgroundColor: lightMode ? theme.palette.grey[700] : theme.palette.grey[400]
                    }
                }),
                // TEXT
                ...(textVariant && {
                    '&:hover': {
                        backgroundColor: theme.palette.grey['500Transparent'][24]
                    }
                }),
                // SOFT
                ...(softVariant && {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.grey['500Transparent'][8],
                    '&:hover': {
                        backgroundColor: theme.palette.grey['500Transparent'][24]
                    }
                }),
                // WHITE
                ...(whiteVariant && {
                    color: theme.palette.grey[800],
                    backgroundColor: theme.palette.common.white,
                    '&:hover': {
                        backgroundColor: theme.palette.grey[200]
                    }
                }),
                // OUTLINED - handling only inherit color styles
                ...(outlinedVariant && {
                    borderColor: inheritColor ? theme.palette.grey['500Transparent'][32] : 'currentColor',
                    '&:hover': {
                        borderColor: 'currentColor',
                        boxShadow: '0 0 0 0.5px currentColor',
                        backgroundColor: alpha(theme.palette.action.hover, 0.08)
                    }
                })
            })
        };
        const colorStyle = COLORS.map((color) => ({
            ...(ownerState.color === color && {
                // // OUTLINED - handling all other color styles
                // OUTLINED
                ...(outlinedVariant && {
                    color: theme.palette.grey[900],
                    borderColor: theme.palette.common.grey.dark,
                    '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                        color: theme.palette.grey[900]
                    },
                    [`&.${buttonClasses.disabled}`]: {
                        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                            color: theme.palette.action.disabledBackground
                        }
                    },
                    '&:hover': {
                        borderColor: theme.palette[ownerState.color].main,
                        backgroundColor: theme.palette[ownerState.color].main,
                        color: theme.palette[ownerState.color]?.shades?.contrastText ||
                            theme.palette[ownerState.color].contrastText,
                        boxShadow: '0 0 0 0.5px currentColor',
                        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                            color: theme.palette[ownerState.color]?.shades?.contrastText ||
                                theme.palette[ownerState.color].contrastText
                        }
                    }
                }),
                // ...(outlinedVariant && {
                //   borderColor: inheritColor ? theme.palette.grey['500Transparent'][32] : 'currentColor',
                //   '&:hover': {
                //     borderColor: inheritColor ? theme.palette.grey[900] : 'currentColor',
                //     boxShadow: '0 0 0 0.5px currentColor',
                //     backgroundColor: inheritColor
                //       ? alpha(theme.palette.action.hover, 0.08)
                //       : alpha(theme.palette[ownerState.color].main, 0.08)
                //   }
                // }),
                // CONTAINED
                ...(containedVariant && {
                    // Check if VDK groep by checking selectedCompany name
                    ...(color === 'primary' &&
                        isVDKGroep && {
                        // VDK groep primary contained button
                        backgroundColor: '#00244D',
                        color: '#FFFFFF',
                        boxShadow: 'none',
                        border: '1px solid #00244D',
                        '&:hover': {
                            backgroundColor: '#00244D',
                            border: '1px solid #00244D',
                            boxShadow: 'none'
                        },
                        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                            color: '#FFFFFF' // White icons
                        }
                    }),
                    // Check if VDK groep secondary by checking selectedCompany name
                    ...(color === 'secondary' &&
                        isVDKGroep && {
                        // VDK groep secondary contained button
                        backgroundColor: '#3192D0',
                        color: '#FFFFFF',
                        boxShadow: 'none',
                        border: 'none',
                        '&:hover': {
                            backgroundColor: theme.palette[color]?.shades?.[80] ||
                                alpha(theme.palette[color].main, 0.8),
                            border: `1px solid ${theme.palette[color]?.shades?.[100] || theme.palette[color].main}`,
                            boxShadow: 'none'
                        },
                        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                            color: '#FFFFFF' // White icons
                        }
                    }),
                    // Default behavior for other companies or colors
                    ...(!((color === 'primary' && isVDKGroep) || (color === 'secondary' && isVDKGroep)) && {
                        backgroundColor: theme.palette[color]?.shades?.[100] || theme.palette[color].main,
                        color: theme.palette[color]?.shades?.contrastText ||
                            theme.palette[color].contrastText,
                        borderColor: theme.palette[color]?.shades?.[100] || theme.palette[color].main,
                        boxShadow: 'none',
                        border: `1px solid ${theme.palette[color]?.shades?.[100] || theme.palette[color].main}`,
                        '&:hover': {
                            backgroundColor: theme.palette[color]?.shades?.[80] ||
                                alpha(theme.palette[color].main, 0.8),
                            border: `1px solid ${theme.palette[color]?.shades?.[100] || theme.palette[color].main}`,
                            boxShadow: 'none'
                        },
                        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                            color: theme.palette[color]?.shades?.contrastText ||
                                theme.palette[color].contrastText
                        }
                    })
                }),
                // TEXT
                ...(textVariant && {
                    '&:hover': {
                        backgroundColor: alpha(theme.palette[ownerState.color].main, 0.08)
                    }
                }),
                // SOFT
                ...(softVariant && {
                    color: theme.palette[color][lightMode ? 'darker' : 'lighter'],
                    backgroundColor: alpha(theme.palette[color].main, 0.08),
                    '&:hover': {
                        backgroundColor: alpha(theme.palette[color].main, 0.16)
                    }
                }),
                // WHITE
                ...(whiteVariant && {
                    color: theme.palette[color].main,
                    backgroundColor: theme.palette.common.white,
                    '&:hover': {
                        backgroundColor: theme.palette.grey[200]
                    }
                })
            })
        }));
        const disabledState = {
            [`&.${buttonClasses.disabled}`]: {
                // SOFT
                ...(softVariant && {
                    backgroundColor: theme.palette.action.disabledBackground
                }),
                // CONTAINED - remove colored border when disabled
                ...(containedVariant && {
                    border: 'none',
                    color: theme.palette.action.disabledBackground
                }),
                ...(outlinedVariant && {
                    borderColor: theme.palette.action.disabledBackground,
                    color: theme.palette.action.disabledBackground
                })
            }
        };
        const size = {
            ...(smallSize && {
                height: 34,
                fontSize: 13,
                paddingLeft: 8,
                paddingRight: 8,
                borderRadius: 10,
                ...(textVariant && {
                    paddingLeft: 4,
                    paddingRight: 4
                })
            }),
            ...(mediumSize && {
                height: 40,
                fontSize: 14,
                paddingLeft: 12,
                paddingRight: 12,
                borderRadius: 14,
                ...(textVariant && {
                    paddingLeft: 8,
                    paddingRight: 8
                })
            }),
            ...(largeSize && {
                height: 48,
                fontSize: 15,
                paddingLeft: 16,
                paddingRight: 16,
                borderRadius: 16,
                ...(textVariant && {
                    paddingLeft: 10,
                    paddingRight: 10
                })
            }),
            ...(xlSize && {
                height: 56,
                paddingLeft: 24,
                paddingRight: 24,
                borderRadius: 16
            })
        };
        return [defaultStyle, ...colorStyle, disabledState, size];
    };
    return {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => rootStyles(ownerState)
            }
        }
    };
}
